import { upsertDraftAmends } from "authoring/routes/project/schedule-editor/controller/upsert-draft-amends"
import { deleteAuthoringAmends } from "./delete-authoring-amends"
import { stripChipHtml } from "authoring/routes/macro/lib/macro-chip-utils"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"

export function createDraftAmendHandlers({ projectId, scheduleId }) {
    return { saveAmend, deleteAmend }

    async function saveAmend({ amendsKey: key, content, internalContent, externalContent, noteMode }) {
        if (!projectId || !scheduleId || !key) return null
        try {
            const saved = await upsertDraftAmends({
                projectId,
                scheduleId,
                amends: {
                    amendsKey: key,
                    content: stripChipHtml(content),
                    internalContent: stripChipHtml(internalContent),
                    externalContent: stripChipHtml(externalContent),
                    noteMode,
                },
            })
            if (!saved) {
                errorSnackbar("Failed to save author notes")
                return null
            }
            successSnackbar("Author notes saved")
            return saved
        } catch (error) {
            errorSnackbar("Failed to save author notes")
            throw error
        }
    }

    async function deleteAmend({ id } = {}) {
        if (!projectId || !id) return null
        try {
            const deleted = await deleteAuthoringAmends({ projectId, amendsId: id })
            successSnackbar("Author notes deleted")
            return deleted
        } catch (error) {
            errorSnackbar("Failed to delete author notes")
            throw error
        }
    }
}
